<template>
    <el-dialog v-dialogDrag class="dataroom-el-dialog" :append-to-body="true" :before-close="cancel" width="500px"
        :title="dataForm.id !== '' ? '编辑标签' : '新增标签'" :visible.sync="formVisible">
        <el-form ref="ruleForm" :model="dataForm" :rules="rules" label-position="right" label-width="90px"
            class="form-container bs-el-form">
            <el-form-item label="标签名称" prop="name">
                <el-input v-model="dataForm.name" class="bs-el-input" clearable placeholder="请输入标签名称" maxlength="200" />
            </el-form-item>
            <el-form-item label="标签说明" prop="description">
                <el-input v-model="dataForm.description" clearable placeholder="请输入标签说明" class="bs-el-input"
                    type="textarea" />
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button class="bs-el-button-default" @click="cancel">
                取消
            </el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">
                确定
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    name: 'LabelEdit',
    data() {
        return {
            loading: false,
            datasetList: [],
            typeId: '',
            dataForm: {
                name: '',
                description: '',
                enterprise: localStorage.getItem('enterprise_id'),
            },
            formVisible: false,
            rules: {
                name: [
                    { required: true, message: '标签名称不能为空', trigger: 'blur' },
                ],
            },
            categoryData: [],
            relVisible: false,
            datasetIdList: []
        }
    },
    watch: {
        'dataForm.labelType': function (val) {
            if (val.length > 20) {
                this.dataForm.labelType = val.substring(0, 20)
            }
        }
    },
    methods: {
        /**
         * 初始化
         * @param row 标签信息
         */
        init(row) {
            this.formVisible = true
            this.$nextTick(() => {
                this.$refs.ruleForm.resetFields()
                if (row) {
                    this.dataForm.id = row.id
                    this.dataForm.name = row.name
                    this.dataForm.description = row.description
                }
            })
        },
        /**
         * 表单关闭
         */
        handleClose() {
            this.$parent.editFormVisible = false
        },
        /**
         * 取消按钮
         */
        cancel() {
            this.formVisible = false
            this.$nextTick(() => {
                this.handleClose()
            })
        },
        /**
         * 提交按钮
         * @param formName
         */
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.saveForm(true)
                } else {
                    return false
                }
            })
        },
        /**
         * 保存标签信息
         * @param flag
         */
        saveForm(flag) {
            if (this.dataForm.id) {
                this.$tools
                    .asyncPost(this, this.$baseUrl.labeledit, {
                        data: {
                            ...this.dataForm
                        }
                    })
                    .then((res) => {
                        if (res.data.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            })
                            this.cancel()
                            this.$emit('afterEdit')
                        } else {
                            this.$message({ type: "error", message: res.data.err });
                        }
                    })
                    .catch(() => {

                    });
            } else {
                this.$tools
                    .asyncPost(this, this.$baseUrl.labeladd, {
                        data: {
                            ...this.dataForm
                        }
                    })
                    .then((res) => {
                        if (res.data.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            })
                            this.cancel()
                            this.$emit('afterEdit')
                        } else {
                            this.$message({ type: "error", message: res.data.err });
                        }
                    })
                    .catch(() => {

                    });
            }

        },
        selectBlur(e) {
            this.dataForm.labelType = e.target.value
        },
        // 对输入字符串控制
        filterData() {
            // 此属性得到输入的文字
            const str = this.$refs.searchSelect.$data.selectedLabel
            // 控制的js
            if (str.length > 20) {
                this.$refs.searchSelect.$data.selectedLabel = str.substr(0, 20)
            }
        }
    }
}
</script>

<style scoped>
.form-container {
    padding: 0 8px;
}
</style>
